/**
 * src/components/business-page/BusinessCTA.js
 *
 * Bloque CTA inferior: "¿Te interesa este negocio? Contacta por WhatsApp".
 * Props: { whatsapp, name }
 */

import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { uiIcons } from '@/shared/brandIcons.js'
import { waLink } from '@/shared/utils/whatsapp.js'

define('BusinessCTA', ({ whatsapp, name }) => {
    return h('div', { className: 'biz-cta' },
        h('p',  { className: 'biz-cta__question' },
            `¿Te interesa ${name}?`
        ),
        h('p',  { className: 'biz-cta__sub' },
            'Contacta directamente por WhatsApp'
        ),
        h('a', {
            className: 'biz-cta__btn',
            href:      waLink(whatsapp),
            target:    '_blank',
            rel:       'noopener',
            innerHTML: uiIcons.whatsapp + ' Hablar por WhatsApp' })
    )
})
